import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import SEO from '../../components/SEO';
import { customerAuthApi } from '../../services/customerAuthApi';
import { useAuth } from '../../context/AuthContext';
import { isPrerendering } from '../../prerenderData';
import './AuthPage.css';

function VerifyEmailPage() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const token = params.get('token') || '';
  const [status, setStatus] = useState('working');
  const [error, setError] = useState('');

  useEffect(() => {
    // Pre-render the "working" state: it is what the client renders first.
    if (isPrerendering) return;
    if (!token) { setStatus('error'); setError('Verification link is missing a token.'); return; }
    customerAuthApi.verify({ token })
      .then(() => { setStatus('done'); refresh(); })
      .catch((err) => { setStatus('error'); setError(err.message); });
  }, [token, refresh]);

  return (
    <div className="auth-page">
      <SEO title="Verify email" description="Confirm the email address on your ASG Shading account so you can sign in and track your orders." canonical="/verify-email" noindex />
      <div className="auth-card">
        <p className="auth-eyebrow">ASG Shading</p>
        {status === 'working' && <>
          <h1 className="auth-title">Verifying…</h1>
          <p className="auth-subtitle">Hang tight while we confirm your email address.</p>
        </>}
        {status === 'done' && <>
          <h1 className="auth-title">Email confirmed</h1>
          <p className="auth-notice">Thanks - your email is verified.</p>
          <p className="auth-meta-center"><Link to="/account">Go to your account →</Link></p>
        </>}
        {status === 'error' && <>
          <h1 className="auth-title">Couldn't verify</h1>
          <p className="auth-error">{error}</p>
          <p className="auth-meta-center"><Link to="/account">Back to your account</Link></p>
        </>}
      </div>
    </div>
  );
}

export default VerifyEmailPage;
